import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "info" }
const _hoisted_4 = {
  key: 0,
  class: "date"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "fas fa-calendar" }, null, -1 /* HOISTED */)
const _hoisted_6 = { class: "title" }
const _hoisted_7 = {
  key: 0,
  class: "more"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.chunks, (chunk, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: "wrapper"
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chunk, (article) => {
            return (_openBlock(), _createElementBlock("div", {
              key: article.id,
              class: "col-md-3"
            }, [
              _createElementVNode("a", {
                href: article.url,
                class: "item"
              }, [
                _createElementVNode("div", {
                  class: "image",
                  style: _normalizeStyle({
                  '--image': `url(${article.attrs && article.attrs.news_image ? article.attrs.news_image.url : ''})`,
                  '--category': `'${$options.categoryName(article)}'`,
                  '--icon': `url(${$options.categoryIcon(article)})`,
                })
                }, null, 4 /* STYLE */),
                _createElementVNode("div", _hoisted_3, [
                  (article.attrs.news_date)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _hoisted_5,
                        _createTextVNode(" " + _toDisplayString($options.date(article)), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(article.local.title), 1 /* TEXT */)
                ])
              ], 8 /* PROPS */, _hoisted_2)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]))
    }), 128 /* KEYED_FRAGMENT */)),
    ($data.page < $data.pages)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.fetchArticles($data.page+1, $data.perPage)))
          }, [
            ($data.loading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(_ctx.translate('Loading...')), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.translate('Load More')), 1 /* TEXT */))
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}